import styled from "styled-components";

export const TherapistsTitle = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.black};
`;

export const Container = styled.div.attrs({})`
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
`;

export const Header = styled.div.attrs({})`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
    gap: 16px;
`;

export const TabContainer = styled.div.attrs({})`
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
  padding-bottom: 6px;
`;

export const Tab = styled.button`
    background: none;
    border: none;
    padding: 10px 18px 12px;
    font-size: 16px;
    font-weight: ${({ active }) => (active ? 700 : 500)};
    color: ${p => p.active ? p.theme.palette.colors.text : p.theme.palette.colors.subdued};
    position: relative;
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.22s ease;

    &:after {
        content: "";
        display: ${({ active }) => (active ? "block" : "none")};
        width: 100%;
        height: 3px;
        background: ${p => p.theme.palette.blue.main};
        position: absolute;
        bottom: -8px;
        left: 0;
        border-radius: 999px;
    }
`;
